import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const ResultsContainer = styled.div`
  background-color: ${COLORS.grey5};
`;

export const PageMargin = styled.div``;

export const ResultsWrapper = styled.div`
  padding-top: 40px;
  @media ${device.tablet} {
    padding-top: 52px;
  }
`;

export const ResultsPadding = styled.div``;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLORS.grey15};
  margin: 52px 0;
  @media ${device.laptop} {
    margin: 76px 0;
  }
`;

export const GroupTitleWrapper = styled.div`
  padding-bottom: 8px;
`;

export const ModelTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const NoOffersWrapper = styled.div`
  width: 100%;
  max-width: 824px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  flex-direction: column;
  gap: 25px;
  align-items: flex-end;
  @media ${device.tablet} {
    align-items: center;
  }
`;

export const ViewCashCta = styled.button`
  cursor: pointer;
  display: flex;
  color: ${COLORS.black};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
  font-family: 'Audi Type';
  background-color: transparent;
  border: none;
  align-items: center;
  padding: 1px 0;
`;
